import {MessageContentType} from "@/types/message";

export const toSlug = (text: string): string => {
    return text
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s]+/g, "-")
        .replace(/[^a-zA-Z0-9\u0600-\u06FF-]/g, "")
        .replace(/^-+|-+$/g, "");
};

const zero = 'صفر';
const negative = 'منفی ';
const delimiter = ' و ';
const units = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون'];
const ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const tens = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
const teens = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];

function splitByThrees(numStr: string): string[] {
    const padded = numStr.padStart(Math.ceil(numStr?.length / 3) * 3, '0');
    return padded.match(/\d{3}/g) || [];
}

function threeDigitToWords(numStr: string): string {
    const [h, t, o] = numStr.split('').map(Number);
    const parts: string[] = [];

    if (h) parts.push(hundreds[h]);
    if (t === 1) {
        parts.push(teens[o]);
    } else {
        if (t) parts.push(tens[t]);
        if (o) parts.push(ones[o]);
    }

    return parts.join(delimiter);
}

export function numToPersian(input: number | string, unit: string = 'تومان'): string {
    if (typeof input !== 'number') {
        input = Number(String(input).replace(/[^0-9.-]/g, ''));
    }

    if (Number.isNaN(input)) return zero;

    input = Math.floor(input / 10);

    if (input === 0) return `${zero} ${unit}`;

    const isNeg = input < 0;
    const absStr = Math.abs(input).toString();
    const chunks = splitByThrees(absStr);
    const words: string[] = [];

    for (let i = 0; i < chunks?.length; i++) {
        const word = threeDigitToWords(chunks[i]);
        if (word) {
            const unitName = units[chunks?.length - i - 1];
            words.push(`${word} ${unitName}`.trim());
        }
    }

    return `${isNeg ? negative : ''}${words.join(delimiter)} ${unit}`;
}

export function formatFileSize(bytes: number): string {
    if (!bytes || bytes <= 0) return "0 KB";

    const KB = 1024;
    const MB = KB * 1024;

    if (bytes < MB) {
        return `${Math.round(bytes / KB)} KB`;
    }

    return `${(bytes / MB).toFixed(2)} MB`;
}


export function buildLastMessageText(
    contentType: MessageContentType,
    text?: string,
    fileName?: string
): string {
    switch (contentType) {
        case MessageContentType.TEXT:
            return text ?? "";

        case MessageContentType.EMOJI:
            return text ?? "ایموجی";

        case MessageContentType.AUDIO:
            return "پیام صوتی 🔊";

        case MessageContentType.IMAGE:
            return `تصویر 📷${fileName ? `: ${fileName}` : ""}`;

        case MessageContentType.FILE:
            return `فایل 📄${fileName ? `: ${fileName}` : ""}`;

        case MessageContentType.UNKNOWN:
        default:
            return "محتوای ناشناخته";
    }
}